import { headlines, LEVEL_LABEL, statusCards } from "@/lib/insights";
import { money } from "@/lib/format";

export const StatusCards = ({ s, cur, compact = false, testId = "status-cards" }) => {
  const m = (v) => money(v, cur);
  return (
    <div className={compact ? "status-grid is-compact" : "status-grid"} data-testid={testId}>
      {statusCards(s, m).map((c) => (
        <div key={c.key} className={`status-card lvl-${c.level}`} data-testid={`${testId}-${c.key}`}>
          <div className="flex items-center justify-between gap-2">
            <span className="status-title">{c.title}</span>
            <span className="status-pill">{LEVEL_LABEL[c.level]}</span>
          </div>
          <span className="status-value font-mono">{c.value}</span>
          <span className="status-text">{c.text}</span>
        </div>
      ))}
    </div>
  );
};

export const Headlines = ({ s, cur, testId = "headlines" }) => {
  const m = (v) => money(v, cur);
  return (
    <div className="headline-grid" data-testid={testId}>
      {headlines(s, m).map((h) => (
        <div key={h.key} className={`headline lvl-${h.level}`} data-testid={`${testId}-${h.key}`}>
          <span className="headline-q">{h.q}</span>
          <span className="headline-a">{h.a}</span>
          <span className="headline-t">{h.text}</span>
        </div>
      ))}
    </div>
  );
};
